module.exports = __webpack_public_path__ + "img/notification.3208bc71.svg";